// Simple toast utility to mimic react-hot-toast
export const toast = (message) => {
  console.log(`[Toast] ${message}`);
};

toast.success = (message) => {
  console.log(`[Toast SUCCESS] ${message}`);
};

toast.error = (message) => {
  console.error(`[Toast ERROR] ${message}`);
};

export default toast;
